import {
    Box,
    Flex,
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
    Spinner,
    Text,
    Badge,
    Button
} from '@chakra-ui/react'
import { Link } from 'react-router-dom';
import { MdOutlineChevronRight } from "react-icons/md";
import React, { Fragment } from 'react'
import AllFillters from './Layout/AllFillters';
import { ArrowDownIcon, ArrowUpIcon } from '@chakra-ui/icons'

const AllTenure = ({ title, head, data, isLoading }) => {

    const [arrow, setArrow] = React.useState(true)

    const sortData = () => {
      if (arrow === true) {
        console.log("down");
        data.sort((a, b) => new Date(a.startDate) - new Date(b.startDate));
      }
      if (arrow === false) {
        console.log("up")
        data.sort((a, b) => new Date(b.startDate) - new Date(a.startDate));
      }
      setArrow(!arrow);
    };

//    data.sort((a, b) => {
//     const dateA = new Date(a.startDate);
//     const dateB = new Date(b.startDate);

//     if (dateA < dateB) {
//         return 1;
//     } else if (dateA > dateB) {
//         return -1;
//     } else {
//         return 0;
//     }
// });





    return (
        <Fragment>
            
            <AllFillters
                title={title}
                data={data}
                create={"Tenure"}
                filters = {[]}
            />
            <Box maxW={'full'} my={4} >
                <TableContainer height={`${window.innerHeight - 244}px`} overflowY={'scroll'}>
                    <Table variant={'simple'} size={'xs'}>
                        <Thead bgColor={'gray.100'} position={'sticky'} top={'0px'} zIndex={'99'}>
                            <Tr bgColor={'#E2DFDF'}>
                                {head.map((h, i) => (
                                    <Th key={i} fontSize={'xs'} py={3} _first={{paddingLeft: '20px'}} color={'#25282B'}>{h === "Order" ? <Button variant='outline' onClick={()=>sortData()} rightIcon={arrow === true ? <ArrowDownIcon/> : <ArrowUpIcon/>}>{h}</Button> : h}</Th>
                                ))}
                            </Tr>
                        </Thead>
                        
                        <Tbody>
                        {(data && data.length > 0) ?
                        <>
                            {data.map((d, i) => (
                                
                                <Tr key={i} bgColor={'white'}>
                                    <Td fontSize={'xs'} py={3} pl={5}>#{d.id.split('-')[4]}</Td>
                                    {/* <Td fontSize={'xs'} py={3}>#{d?.TenureItem[0]?.orderId.split('-')[4] || 'not available'}</Td> */}
                                    <Td fontSize={'xs'} py={3}>
                                    <Link to={`/orders/order/${d?.TenureItem[0]?.orderId}`}>
                                        <Text color={'blue.500'}>{d?.ordeName || '----'}</Text>
                                        
                                    </Link>
                                    </Td>
                                    <Td fontSize={'xs'} py={3}>{d?.tenurePeriodId || '-----'}</Td>
                                    <Td fontSize={'xs'} py={3}>{d?.tenurePeriodId === "MONTHLY" ?  (d?.TenureItem[0]?.months !== undefined) ? d?.TenureItem[0]?.months === 1 ? d?.TenureItem[0]?.months + " Month" : d?.TenureItem[0]?.months + " Months" : '----' : (d?.TenureItem[0]?.weeks !== undefined) ? d?.TenureItem[0]?.weeks === 1 ? d?.TenureItem[0]?.weeks + " Week" : d?.TenureItem[0]?.weeks + ' Weeks' : '----'}</Td>
                                    {/* <Td fontSize={'xs'} py={3}>{new Date(d.startDate).toLocaleDateString('en-IN') || '-----'}</Td> */}
                                    <Td fontSize={'xs'} py={3}>{new Date(d.endDate).toLocaleDateString('en-IN') || '----'}</Td>
                                    {/* <Td fontSize={'xs'} py={3}>{'----'}</Td> */}
                                    <Td fontSize={'xs'} py={3}><Badge colorScheme={d?.statusId === 'CANCELED' ? 'red': d?.statusId === 'CREATED' ? 'purple' : d?.statusId === 'EXTENDED' ? 'yellow' : d?.statusId === 'ACTIVE' ? 'green' : 'gray'}>
                                    {d?.statusId === null ? '---' : (d?.statusId?.charAt(0).toUpperCase() + d?.statusId?.slice(1).toLowerCase())}
                                    </Badge></Td>
                                    <Td fontSize={'xs'}>
                                        <Flex>
                                            <Box bgColor={'gray.200'} rounded={'full'} my="auto" p={2} mx={2}>
                                                <Link to={`/tenures/order/${d.TenureItem[0]?.orderId || '#'}/tenure/${d.id}`}><MdOutlineChevronRight /></Link>
                                            </Box>
                                        </Flex>
                                    </Td>
                                </Tr>
                             ))}
                             </>
                         : 
                         <Tr>
                        
                          <Td></Td>
                          <Td></Td>
                          <Td></Td>
                          <Td textAlign={'left'}>
                          {isLoading.loading === true ?
                            <Spinner
                            thickness='4px'
                            speed='0.65s'
                            emptyColor='gray.200'
                            color='blue.500'
                            size='xl'
                            mt={4}
                        
                          />
                          :
                          isLoading.error === true ? <Text fontWeight={'semibold'} color={'red.500'}>Oops we are facing some temporary issue with your request</Text> : <Text  fontWeight={'semibold'} color={'green.500'}>NO TENURE AVAILABLE</Text>
                          } 
                          </Td>
                          <Td >
                          </Td>
                          <Td></Td>
                          <Td></Td>
                          <Td></Td>
                       
                         </Tr>
                        }
                        </Tbody>
                    </Table>
                </TableContainer>
            </Box>
        </Fragment>
    )
}

export default AllTenure
